import React from 'react';
import { observer, inject } from 'mobx-react';
import { Modal, Switch } from 'antd';
const { confirm } = Modal;

const store = [
  'sysStore',
  'ecodeDemoStore',
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'sys'
  }
  componentDidMount() {
    this.callApis();
  }
  callApis = () => {
    const { location: { pathname }, sysStore: { getSysPerson } } = this.props;
    const key = pathname.split('/').reverse()[0];
    if (key === 'user' || key === 'userPwd') getSysPerson();
  }
  onSwitchChange = (v) => {
    const { ecodeDemoStore: { setSwitch } } = this.props;
    confirm({
      title: v ? '确认打开共享开关吗?' : '确认关闭共享开关吗?',
      onOk() {
        setSwitch(v);
      },
    });
  }
  getSwitch = () => {
    const { ecodeDemoStore: { switchValue } } = this.props;
    return (<div>
      <span>共享开关（是否允许提交或下载）</span>
      <Switch
        checked={switchValue == 'y'}
        onChange={this.onSwitchChange}
      />
    </div>)
  }
  render() {
    const {
      prefixCls,
      location: { pathname },
    } = this.props;
    const key = pathname.split('/')[0];
    return (
      <div className={`${prefixCls}`}>
        {
          key === 'ecodeDemo' && (
            <div className="sys-ecode-btn">
              {this.getSwitch()}
            </div>
          )
        }
        <div className={`${prefixCls}-con`}>
          {this.props.children}
        </div>        
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/SysPortal.js